// extracted by mini-css-extract-plugin
export default {"modal":"SignupDetails_modal__I+NDO","signupDetailsMain":"SignupDetails_signupDetailsMain__z-TMC","signupDetailsBody":"SignupDetails_signupDetailsBody__xa53J"};